import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useDateNow } from 'ziphy-web-shared/basic/hooks';
import { formatDate } from 'ziphy-web-shared/basic/utils/time';
export const DateNow = ({ timezone, format = 'datetimeFullNoYear' }) => {
    const now = useDateNow(timezone);
    return _jsx(_Fragment, { children: formatDate(now, { timezone, format }) });
};
